<template>
  <v-text-field
      clearable
      @click:clear="()=> {this.text = ' '; this.$emit('search', ' ')}"
      id="buscador"
      :label="$t('Buscar')"
      v-model="text"
      solo
  />
</template>

<script>
export default {
  name: "Buscador",

  data: () => ({
    contador: null,
    tiempo_espera: 500,
    text: null
  }),

  methods: {
    /**
     * Lanza el evento cuando el usuario ha parado de escribir durante el tiempo de espera.
     */
    fin_de_escritura() {
      this.$emit('search', this.text?this.text:' ')
    },
    function_timeout_search() {
      clearTimeout(this.contador);
      this.contador = setTimeout(this.fin_de_escritura, this.tiempo_espera);
    }

  },

  watch: {
    text() {
      // watch en vez de keydown para que funcione con escaner de código de barras
      this.function_timeout_search()
    }
  }
}
</script>